<template>
  <div class="areas" @click="onSelectArea">
    <img src="../../../assets//img-v2/ic_home_stop.png" class="stop" />
    <div class="title">运营区域</div>
    <div class="dot"></div>
    <div v-if="currentAreaName" class="box">
      <div class="area">{{ currentAreaName }}</div>
      <img src="../../../assets//img-v2/ic_home_arrow.png" class="arrow" />
    </div>
    <span class="area" v-show="!currentAreaName">（暂无）</span>
  </div>
</template>

<script>
export default {
  name: "AreaSelector",
  props: {
    currentArea: {
      type: Object,
      default: null,
    },
  },
  computed: {
    currentAreaName() {
      const { name } = this.currentArea || {};
      return name || "";
    },
  },
  data() {
    return {
    };
  },
  methods: {
    onSelectArea() {
      this.$emit("select");
    },
  },
};
</script>

<style scoped lang="scss">
.areas {
  width: 100%;
  height: 42px;
  line-height: 51px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  overflow: hidden;

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    text-align: left;
    font-style: normal;
  }

  .dot {
    width: 4px;
    height: 4px;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 50%;
    margin: 0 6px;
  }

  .box {
    flex: 1;
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  .area {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .stop {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  .arrow {
    width: 16px;
    height: 16px;
    margin-left: 6px;
  }
}
</style>
